module.exports = __webpack_public_path__ + "static/media/step-indicator-1.bd9f70ab.svg";